const LoadingSpinner = () => {
  return (
    <div className="spinner_container">
      <div className="loading_spinner"></div>
    </div>
  )
}

export default LoadingSpinner
